import React, {Fragment} from 'react';
import { connect } from "react-redux";
import invert from "lodash/invert";

import {loaderEnable} from "../ui/loaderView";
import {
  toggleUserPopup, setCanvasId, setLayoutDataParts, setDefaultSelectionGroup, loadFilters, setCameFromPage,
  toggleBathroomVisualizerOpen, toggleSelectionFeatureInfo, changeMessageBoxState, addVisualizersLoaded
} from "../../actions/actionFunctions";
// import './assets/css/styles.css';
import {
  getBathroomVisualizerData,
  getBvGroups,
  getQtCategories,
  getNavigationButtons
} from "../../api/server-api";
import ImageCanvasCommon from "../visComponents/imageCanvasCommon";
import {Layout} from "./core/layout";
import DesktopNavigation from "./navigation/desktopNavigation";
import MobileNavigation from "./navigation/mobileNavigation";
// import MobileRotateButton from './common/mobileRotateButton';
import MainButtons from "../common/mainButtons";
import DemoPoints from "../common/demoPoints/demoPoints";
import MessageBox from "../popups/messageBox";

import Visualizer from "../visComponents/visualizer";
import VisualizerTutorial from "../tutorials/visualizerTutorial";
import {LayoutType} from "./core/constants";
import {showVisualizerTutorial} from "../../actions/tutorialFunctions";
import Copyright from "../ui/copyright";
import {IS_QKB_UI} from "../../config";

export const layout = new Layout();

class BathroomVisualizer extends Visualizer {

  static displayName = 'BathRoom visualizer';

  constructor(props) {
    super(props);
    this.layout = layout;
  }

  componentDidMount() {
    if (this.props.visualizersLoaded.includes(this.layout.visualizerType)) {
      this.setSubscribers();
      return false
    }
    loaderEnable();
    Promise.all([
      getBathroomVisualizerData(),
      getQtCategories(this.layout.getCurrentLayoutAbbreviation())
    ]).then(baseResponse => {
      Promise.all([
        Promise.resolve(baseResponse[0]),
        getBvGroups(),
        Promise.resolve(baseResponse[1])
      ])
      .then((allResponse) => {
        const mainResponse = allResponse[0];
        const bvGroupsResponse = allResponse[1].data;
        const qtCategories = allResponse[2];
        this.layout.loadNewFeatures(mainResponse); // 1) set default (placeholders)
        this.layout.setGroupsItemsCount(bvGroupsResponse); // should be loaded before & after all features are received
        return this.setVisualizerInfo(mainResponse, bvGroupsResponse, qtCategories, invert(LayoutType));
      })
      .then(this.checkShareUrl)
      .then(this.onBvLoad)
      .then(this.finishLoading);
    });

    this.setSubscribers();
    getNavigationButtons();
  }

  render() {

    if (!IS_QKB_UI) {
      return null
    }

    const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;
    const fabricatorSettings = this.props.fabricatorSettings;
    const layers = this.layout.getLayers(showPlaceHolders);
    const layoutType = this.layout.getCurrentLayoutName();
    const isMobile = this.props.windowWidth < 991;
    const showOtherLayouts =
      (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV")
        ? fabricatorSettings && (fabricatorSettings.showSmallDesignForClients
        || (fabricatorSettings.showSmallDesignFromDashboard && document.kvConfig.isBackend))
        : true;
    const showTutorial = this.checkToShowTutorial() && showOtherLayouts;

    return (
      <div className={"main"
      + (this.props.desktopNavigationOpened ? " main--nav-opened" : "")
      + (this.props.activeNavigationParentName ? " main--" + this.props.activeNavigationParentName : "")
      + (this.props.activeNavigationChildName ? " main--" + this.props.activeNavigationChildName : "")
      }>
        <div className="wrapper" >
          {this.props.bvOpened || this.props.bvVisited ? (
            <Fragment>
              <ImageCanvasCommon layers={layers}
                                 canvasId={this.state.canvasId}
                                 ref={(node) => this.imageCanvas = node}
                                 layoutType={layoutType}
                                 layout={this.layout}
                                 width={this.props.canvasDimensions.width}
                                 height={this.props.canvasDimensions.height}
                                 useMouseHovering={this.props.useMouseHovering}
                                 useTouchZoom={this.props.useTouchZoom}
              />
              <Copyright/>
            </Fragment>
          ) : null}
          <MainButtons goToCart={this.goToCart}
                       changeMessageBoxState={this.changeMessageBoxState}
                       resetEverything={this.resetEverything}
                       canvasId={this.state.canvasId}
          />
          {!this.state.demoPointClicked && this.props.canvasId ? (
            <DemoPoints layoutFeatures={this.layout.getFeatures()}
                        layoutType={this.layout.type}
                        canvasId={this.state.canvasId}/>
          ) : null}
        </div>
        {(this.layout.initialized && this.props.bvVisited) ? ( // keep navigation opened if someone got to QT and back
          isMobile ? (
              <MobileNavigation refreshCB={this.handleRefresh}
                                setHoveredLayer={this.setHoveredLayer}
                                canvasId={this.state.canvasId}
                                renderGreenLayerByZindex={this.renderGreenLayerByZindex}
                                setCanvasClass={this.setCanvasClass}
                                resetEverything={this.resetEverything}
                                userIsLoggedIn={this.props.userIsLoggedIn}
                                toggleUserPopup={this.props.toggleUserPopup}
                                changeMessageBoxState={this.changeMessageBoxState}
                                setActiveFeature={this.setActiveFeature}
                                activeFeature={this.state.activeFeature}
                                fabricatorSettings={fabricatorSettings}
                                isPhoneNumberValidated={this.props.isPhoneNumberValidated}
                                setDemoPointClicked={this.setDemoPointClicked}
              />
            ) : (
              <DesktopNavigation ref={(node) => this.navBar = node}
                                 refreshCB={this.handleRefresh}
                                 setHoveredLayer={this.setHoveredLayer}
                                 canvasId={this.state.canvasId}
                                 renderGreenLayerByZindex={this.renderGreenLayerByZindex}
                                 toggleUserPopup={this.props.toggleUserPopup}
                                 changeMessageBoxState={this.changeMessageBoxState}
                                 setActiveFeature={this.setActiveFeature}
                                 activeFeature={this.state.activeFeature}
                                 fabricatorSettings={fabricatorSettings}
                                 setDemoPointClicked={this.setDemoPointClicked}
              />
            )
        ) : null}
        {/*<MobileRotateButton/>*/}
        {this.props.cookieAccepted ? <MessageBox state={this.state.messageBoxState}/> : null}
        {showTutorial ? <VisualizerTutorial isMobile={isMobile}/> : null}
      </div>
    )
  }
}
const mapStateToProps = (store) => {
  const {cookieAccepted, windowWidth, visualizersLoaded} = store.serverState;
  const {bvOpened, bvVisited, canvasId, showRestorePopup, canvasDimensions, canvasCount} = store.bathroomVisualizerState;
  const {mobileNav, desktopNavigationOpened, activeNavigationParentName, activeNavigationChildName} = store.navigationState;
  const {isPhoneNumberValidated, userIsLoggedIn} = store.userState;
  const {visualizerTutorialIsOpened, visualizerTutorialFinished} = store.tutorialState;
  const {initialFlowRoomLayout, initialFlowRoom, initialFlowStep} = store.initialFlowState;
  return {
    bvOpened,
    bvVisited,
    mobileNav,
    isPhoneNumberValidated,
    userIsLoggedIn,
    windowWidth,
    canvasId,
    fabricatorSettings: store.fabricatorState.settings,
    desktopNavigationOpened,
    activeNavigationParentName,
    activeNavigationChildName,
    showRestorePopup,
    visualizerTutorialIsOpened,
    visualizerTutorialFinished,
    initialFlowRoomLayout,
    initialFlowRoom,
    initialFlowStep,
    cookieAccepted,
    canvasDimensions,
    visualizersLoaded,
    canvasCount,
  };
};

export default connect(mapStateToProps, {
  setCameFromPage,
  toggleBathroomVisualizerOpen,
  setDefaultSelectionGroup,
  setLayoutDataParts,
  toggleUserPopup,
  setCanvasId,
  loadFilters,
  toggleSelectionFeatureInfo,
  changeMessageBoxState,
  addVisualizersLoaded,
  showVisualizerTutorial
})(BathroomVisualizer);
